module.exports = __webpack_public_path__ + "static/media/3.1cf6ab21.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/lhand/3.png
// module id = 1334
// module chunks = 0